/** @jsx jsx */
import React from 'react';
import Portal from '@atlaskit/portal';
import { Popper } from '@atlaskit/popper';
import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { useHoverPopoverState } from '../../controllers/hover-popover-state-provider/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../constants.tsx';
import { PopoverInternal } from './popover-internal/index.tsx';

export const HoverPopoverWithDelegator = () => {
	const { hoverPopoverState } = useHoverPopoverState();

	const {
		isOpen,
		content,
		contentElement,
		alwaysShow,
		cellRef,
		onHoverOut,
		shouldRenderToContent,
	} = hoverPopoverState;

	const refToRenderTo = shouldRenderToContent ? contentElement : cellRef;

	return (
		<>
			{isOpen && refToRenderTo && (
				<Portal>
					<UFOSegment name="jira-list-hover-popover" mode="list">
						<JSErrorBoundary
							id="jira-list-hover-popover"
							packageName={PACKAGE_NAME}
							teamName={TEAM_NAME}
							fallback="flag"
						>
							<Popper placement="bottom-start" referenceElement={refToRenderTo}>
								{({ ref, style, update, isReferenceHidden }) => (
									<div
										ref={ref}
										// Style is required for react-popper to apply positioning correctly (allows it to render to parent)
										// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
										style={style}
										css={shouldRenderToContent && renderToContentStyles}
									>
										<PopoverInternal
											content={content}
											contentElement={contentElement}
											onUpdate={update}
											isReferenceHidden={isReferenceHidden}
											alwaysShow={alwaysShow}
											onHoverOut={onHoverOut}
										/>
									</div>
								)}
							</Popper>
						</JSErrorBoundary>
					</UFOSegment>
				</Portal>
			)}
		</>
	);
};

const renderToContentStyles = css({
	marginTop: token('space.100'),
	marginLeft: token('space.negative.100'),
});
